import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "content",
    class: _normalizeClass($options.rootClass),
    onClick: _cache[0] || (_cache[0] = (...args) => ($options.onEventClickDelegation && $options.onEventClickDelegation(...args))),
    innerHTML: $options.processedHtml,
    "data-qa": "richtext-article"
  }, null, 10 /* CLASS, PROPS */, _hoisted_1))
}